import { Alert } from "react-bootstrap";
import { ExclamationCircle } from "react-bootstrap-icons";
import styled from "styled-components";

export const AlertBoxMessage = styled.p`
  && {
    font-size: 0.75em;
    margin: 0;
  }
`;

export const Container = styled.div`
  && {
    display: flex;
    align-items: center;
  }
`;

export const Icon = styled.div`
  && {
    display: flex;
    margin-right: 15px;
  }
`;

// https://icons.getbootstrap.com/
function AlertBox({ show, message = "", customVariant = "danger" }) {
  if (show) {
    return (
      <Alert
        variant={customVariant}
        onClose={() => {
          return !show;
        }}
        style={{ marginTop: "16px" }}
      >
        <Container>
          <Icon>
            <ExclamationCircle size={16} />
          </Icon>
          <AlertBoxMessage>{message}</AlertBoxMessage>
        </Container>
      </Alert>
    );
  }
  return null;
}

export default AlertBox;
